import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationFolateDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const dhfr = getGenePalette(geneColors.DHFR);
  const shmt = getGenePalette(geneColors.SHMT);
  const mthfd1 = getGenePalette(geneColors.MTHFD1);
  const mthfr = getGenePalette(geneColors.MTHFR);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18291_211481)">
        <rect width={1024} height={860} transform="translate(0 142)" fill="white" />
        <g id="folate-diagram">
          <rect width={1024} height={860} transform="translate(0 142)" fill="white" />
          <g id="lines">
            <path
              id="Vector_2"
              d="M675.3 216.742L676 216.742L676 215.342L675.3 215.342L675.3 216.042L675.3 216.742ZM545 216.041L552 220.083L552 212L545 216.041ZM675.3 216.042L675.3 215.342L551.3 215.341L551.3 216.041L551.3 216.741L675.3 216.742L675.3 216.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M215.3 644.742L216 644.742L216 643.342L215.3 643.342L215.3 644.042L215.3 644.742ZM190 644.042L197 648.083L197 640L190 644.042ZM215.3 644.042L215.3 643.342L196.3 643.342L196.3 644.042L196.3 644.742L215.3 644.742L215.3 644.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_4"
              d="M308.742 711.7L308.742 711L307.342 711L307.342 711.7L308.042 711.7L308.742 711.7ZM308.042 769L312.083 762L304 762L308.042 769ZM308.042 711.7L307.342 711.7L307.342 762.7L308.042 762.7L308.742 762.7L308.742 711.7L308.042 711.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles">
            <rect width={174} height={28} transform="translate(698 202)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={698.463} y={222.129}>
                Folic Acid and Folate
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <rect width={54} height={36} transform="translate(136 620)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={136.012} y={634.086}>
                DNA/RNA{" "}
              </tspan>
              <tspan x={138.133} y={650.086}>
                synthesis
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <rect width={110} height={20} transform="translate(253 773)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={253.309} y={787.086}>
                Pyrimidine synthesis
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_4">
              <rect width={46} height={36} transform="translate(490 202)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={490.031} y={228.16}>
                  DHF
                </tspan>
              </text>
            </g>
            <g id="lines_4">
              <path
                id="Vector_5"
                d="M513.658 242.7L513.658 242L512.258 242L512.258 242.7L512.958 242.7L513.658 242.7ZM512.958 368L517 361L508.917 361L512.958 368ZM512.958 242.7L512.258 242.7L512.258 361.7L512.958 361.7L513.658 361.7L513.658 242.7L512.958 242.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Cofactor_3">
            <g id="diamond_2">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={411.184} y={347.086}>
                  NADPH
                </tspan>
              </text>
              <g id="Vector_6">
                <mask id="path-26-inside-2_18291_211481" fill="white">
                  <path d="M431 318L456 330.121V355.879L431 368L406 355.879V330.121L431 318Z" />
                </mask>
                <path
                  d="M431 318L456 330.121V355.879L431 368L406 355.879V330.121L431 318Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-26-inside-2_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_3">
              <text
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={680.947} y={858.767}>
                  B3
                </tspan>
              </text>
              <g id="Vector_7">
                <mask id="path-28-inside-3_18291_211481" fill="white">
                  <path d="M689 829L714 841.121V866.879L689 879L664 866.879V841.121L689 829Z" />
                </mask>
                <path
                  d="M689 829L714 841.121V866.879L689 879L664 866.879V841.121L689 829Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-28-inside-3_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_5">
            <g id="diamond_4">
              <text
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={524.947} y={486.767}>
                  B3
                </tspan>
              </text>
              <g id="Vector_8">
                <mask id="path-30-inside-4_18291_211481" fill="white">
                  <path d="M533 457L558 469.121V494.879L533 507L508 494.879V469.121L533 457Z" />
                </mask>
                <path
                  d="M533 457L558 469.121V494.879L533 507L508 494.879V469.121L533 457Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-30-inside-4_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_6">
            <g id="diamond_5">
              <text
                id="label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={524.947} y={563.767}>
                  B3
                </tspan>
              </text>
              <g id="Vector_9">
                <mask id="path-32-inside-5_18291_211481" fill="white">
                  <path d="M533 534L558 546.121V571.879L533 584L508 571.879V546.121L533 534Z" />
                </mask>
                <path
                  d="M533 534L558 546.121V571.879L533 584L508 571.879V546.121L533 534Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-32-inside-5_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_7">
            <g id="diamond_6">
              <text
                id="label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={581.838} y={563.767}>
                  B6
                </tspan>
              </text>
              <g id="Vector_10">
                <mask id="path-34-inside-6_18291_211481" fill="white">
                  <path d="M590 534L615 546.121V571.879L590 584L565 571.879V546.121L590 534Z" />
                </mask>
                <path
                  d="M590 534L615 546.121V571.879L590 584L565 571.879V546.121L590 534Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-34-inside-6_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_8">
            <g id="diamond_7">
              <text
                id="label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={623.047} y={563.086}>
                  Choline
                </tspan>
              </text>
              <g id="Vector_11">
                <mask id="path-36-inside-7_18291_211481" fill="white">
                  <path d="M644 534L669 546.121V571.879L644 584L619 571.879V546.121L644 534Z" />
                </mask>
                <path
                  d="M644 534L669 546.121V571.879L644 584L619 571.879V546.121L644 534Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-36-inside-7_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_9">
            <g id="diamond_8">
              <text
                id="label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={647.087} y={717.767}>
                  FAD
                </tspan>
              </text>
              <g id="Vector_12">
                <mask id="path-38-inside-8_18291_211481" fill="white">
                  <path d="M660 688L685 700.121V725.879L660 738L635 725.879V700.121L660 688Z" />
                </mask>
                <path
                  d="M660 688L685 700.121V725.879L660 738L635 725.879V700.121L660 688Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-38-inside-8_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_10">
            <g id="diamond_9">
              <text
                id="label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={614.2} y={858.767}>
                  B2
                </tspan>
              </text>
              <g id="Vector_13">
                <mask id="path-40-inside-9_18291_211481" fill="white">
                  <path d="M622 829L647 841.121V866.879L622 879L597 866.879V841.121L622 829Z" />
                </mask>
                <path
                  d="M622 829L647 841.121V866.879L622 879L597 866.879V841.121L622 829Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-40-inside-9_18291_211481)"
                />
              </g>
            </g>
          </g>
          <g id="Report titles_5">
            <rect width={42} height={36} transform="translate(490 381)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={490.188} y={407.16}>
                THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={87} height={36} transform="translate(814 658)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={814.375} y={684.16}>
                5-MTHF
              </tspan>
            </text>
          </g>
          <g id="lines_5">
            <mask id="path-43-inside-10_18291_211481" fill="white">
              <path d="M268 599L268 694L216 694L216 599L268 599Z" />
            </mask>
            <path
              d="M216 694L215.3 694L215.3 694.7L216 694.7L216 694ZM216 599L216 598.3L215.3 598.3L215.3 599L216 599ZM268 599L268 598.3L265.833 598.3L265.833 599L265.833 599.7L268 599.7L268 599ZM261.5 599L261.5 598.3L257.167 598.3L257.167 599L257.167 599.7L261.5 599.7L261.5 599ZM252.833 599L252.833 598.3L248.5 598.3L248.5 599L248.5 599.7L252.833 599.7L252.833 599ZM244.167 599L244.167 598.3L239.833 598.3L239.833 599L239.833 599.7L244.167 599.7L244.167 599ZM235.5 599L235.5 598.3L231.167 598.3L231.167 599L231.167 599.7L235.5 599.7L235.5 599ZM226.833 599L226.833 598.3L222.5 598.3L222.5 599L222.5 599.7L226.833 599.7L226.833 599ZM218.167 599L218.167 598.3L216 598.3L216 599L216 599.7L218.167 599.7L218.167 599ZM216 599L215.3 599L215.3 600.979L216 600.979L216.7 600.979L216.7 599L216 599ZM216 604.937L215.3 604.937L215.3 608.896L216 608.896L216.7 608.896L216.7 604.937L216 604.937ZM216 612.854L215.3 612.854L215.3 616.812L216 616.812L216.7 616.812L216.7 612.854L216 612.854ZM216 620.771L215.3 620.771L215.3 624.729L216 624.729L216.7 624.729L216.7 620.771L216 620.771ZM216 628.687L215.3 628.687L215.3 632.646L216 632.646L216.7 632.646L216.7 628.687L216 628.687ZM216 636.604L215.3 636.604L215.3 640.562L216 640.562L216.7 640.562L216.7 636.604L216 636.604ZM216 644.521L215.3 644.521L215.3 648.479L216 648.479L216.7 648.479L216.7 644.521L216 644.521ZM216 652.437L215.3 652.437L215.3 656.396L216 656.396L216.7 656.396L216.7 652.437L216 652.437ZM216 660.354L215.3 660.354L215.3 664.312L216 664.312L216.7 664.312L216.7 660.354L216 660.354ZM216 668.271L215.3 668.271L215.3 672.229L216 672.229L216.7 672.229L216.7 668.271L216 668.271ZM216 676.187L215.3 676.187L215.3 680.146L216 680.146L216.7 680.146L216.7 676.187L216 676.187ZM216 684.104L215.3 684.104L215.3 688.063L216 688.063L216.7 688.063L216.7 684.104L216 684.104ZM216 692.021L215.3 692.021L215.3 694L216 694L216.7 694L216.7 692.021L216 692.021ZM216 694L216 694.7L218.167 694.7L218.167 694L218.167 693.3L216 693.3L216 694ZM222.5 694L222.5 694.7L226.833 694.7L226.833 694L226.833 693.3L222.5 693.3L222.5 694ZM231.167 694L231.167 694.7L235.5 694.7L235.5 694L235.5 693.3L231.167 693.3L231.167 694ZM239.833 694L239.833 694.7L244.167 694.7L244.167 694L244.167 693.3L239.833 693.3L239.833 694ZM248.5 694L248.5 694.7L252.833 694.7L252.833 694L252.833 693.3L248.5 693.3L248.5 694ZM257.167 694L257.167 694.7L261.5 694.7L261.5 694L261.5 693.3L257.167 693.3L257.167 694ZM265.833 694L265.833 694.7L268 694.7L268 694L268 693.3L265.833 693.3L265.833 694ZM216 694L214.6 694L214.6 695.4L216 695.4L216 694ZM216 599L216 597.6L214.6 597.6L214.6 599L216 599ZM268 599L268 597.6L265.833 597.6L265.833 599L265.833 600.4L268 600.4L268 599ZM261.5 599L261.5 597.6L257.167 597.6L257.167 599L257.167 600.4L261.5 600.4L261.5 599ZM252.833 599L252.833 597.6L248.5 597.6L248.5 599L248.5 600.4L252.833 600.4L252.833 599ZM244.167 599L244.167 597.6L239.833 597.6L239.833 599L239.833 600.4L244.167 600.4L244.167 599ZM235.5 599L235.5 597.6L231.167 597.6L231.167 599L231.167 600.4L235.5 600.4L235.5 599ZM226.833 599L226.833 597.6L222.5 597.6L222.5 599L222.5 600.4L226.833 600.4L226.833 599ZM218.167 599L218.167 597.6L216 597.6L216 599L216 600.4L218.167 600.4L218.167 599ZM216 599L214.6 599L214.6 600.979L216 600.979L217.4 600.979L217.4 599L216 599ZM216 604.937L214.6 604.937L214.6 608.896L216 608.896L217.4 608.896L217.4 604.937L216 604.937ZM216 612.854L214.6 612.854L214.6 616.812L216 616.812L217.4 616.812L217.4 612.854L216 612.854ZM216 620.771L214.6 620.771L214.6 624.729L216 624.729L217.4 624.729L217.4 620.771L216 620.771ZM216 628.687L214.6 628.687L214.6 632.646L216 632.646L217.4 632.646L217.4 628.687L216 628.687ZM216 636.604L214.6 636.604L214.6 640.562L216 640.562L217.4 640.562L217.4 636.604L216 636.604ZM216 644.521L214.6 644.521L214.6 648.479L216 648.479L217.4 648.479L217.4 644.521L216 644.521ZM216 652.437L214.6 652.437L214.6 656.396L216 656.396L217.4 656.396L217.4 652.437L216 652.437ZM216 660.354L214.6 660.354L214.6 664.312L216 664.312L217.4 664.312L217.4 660.354L216 660.354ZM216 668.271L214.6 668.271L214.6 672.229L216 672.229L217.4 672.229L217.4 668.271L216 668.271ZM216 676.187L214.6 676.187L214.6 680.146L216 680.146L217.4 680.146L217.4 676.187L216 676.187ZM216 684.104L214.6 684.104L214.6 688.063L216 688.063L217.4 688.063L217.4 684.104L216 684.104ZM216 692.021L214.6 692.021L214.6 694L216 694L217.4 694L217.4 692.021L216 692.021ZM216 694L216 695.4L218.167 695.4L218.167 694L218.167 692.6L216 692.6L216 694ZM222.5 694L222.5 695.4L226.833 695.4L226.833 694L226.833 692.6L222.5 692.6L222.5 694ZM231.167 694L231.167 695.4L235.5 695.4L235.5 694L235.5 692.6L231.167 692.6L231.167 694ZM239.833 694L239.833 695.4L244.167 695.4L244.167 694L244.167 692.6L239.833 692.6L239.833 694ZM248.5 694L248.5 695.4L252.833 695.4L252.833 694L252.833 692.6L248.5 692.6L248.5 694ZM257.167 694L257.167 695.4L261.5 695.4L261.5 694L261.5 692.6L257.167 692.6L257.167 694ZM265.833 694L265.833 695.4L268 695.4L268 694L268 692.6L265.833 692.6L265.833 694Z"
              fill="#1A1A1A"
              mask="url(#path-43-inside-10_18291_211481)"
            />
          </g>
          <g id="Frame 470">
            <rect x={261.7} y={677.7} width={92.6} height={34.6} rx={3.3} fill="white" />
            <rect
              x={261.7}
              y={677.7}
              width={92.6}
              height={34.6}
              rx={3.3}
              stroke="#282828"
              strokeWidth={1.4}
            />
            <g id="Report titles_7">
              <rect width={62} height={36} transform="translate(277 677)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_7"
                fill="#282828"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={277.145} y={703.196}>
                  dTMP
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_8">
            <rect width={62} height={36} transform="translate(277 581)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={275.785} y={607.196}>
                dUMP
              </tspan>
            </text>
          </g>
          <path
            id="Vector 292"
            d="M358.657 599.818L357.975 599.661L357.661 601.025L358.343 601.182L358.5 600.5L358.657 599.818ZM358.5 695.5L366.226 697.876L364.42 689.997L358.5 695.5ZM358.5 600.5L358.343 601.182C390.243 608.526 414.693 616.132 431.39 623.873C439.739 627.744 446.118 631.634 450.516 635.519C454.919 639.407 457.275 643.233 457.721 646.974C458.165 650.691 456.74 654.486 453.228 658.368C449.707 662.259 444.132 666.188 436.408 670.123C420.964 677.991 397.111 685.797 364.481 693.411L364.64 694.093L364.8 694.774C397.463 687.153 421.447 679.316 437.043 671.37C444.839 667.399 450.584 663.378 454.266 659.307C457.957 655.228 459.617 651.048 459.111 646.808C458.608 642.59 455.978 638.475 451.443 634.47C446.903 630.46 440.391 626.503 431.978 622.603C415.151 614.801 390.592 607.169 358.657 599.818L358.5 600.5Z"
            fill="#282828"
          />
          <g id="Report titles_9">
            <rect width={115} height={36} transform="translate(435 677)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={435.09} y={703.16}>
                5,10-MTHF
              </tspan>
            </text>
          </g>
          <path
            id="Ellipse 5"
            d="M547 368.947L555.082 368.844L550.952 361.896L547 368.947ZM888 560H887.3C887.3 587.346 882.385 613.543 873.39 637.756L874.046 638L874.702 638.244C883.754 613.877 888.7 587.515 888.7 560H888ZM664 336V336.7C787.325 336.7 887.3 436.675 887.3 560H888H888.7C888.7 435.902 788.098 335.3 664 335.3V336ZM552.411 365.73L552.761 366.336C585.512 347.484 623.495 336.7 664 336.7V336V335.3C623.244 335.3 585.02 346.151 552.062 365.123L552.411 365.73Z"
            fill="#282828"
          />
          <path
            id="Ellipse 5_2"
            d="M827.607 713L819.842 715.242L825.666 720.846L827.607 713ZM823.238 717.541L822.741 717.048C782.266 757.957 726.093 783.3 664 783.3V784V784.7C726.482 784.7 783.009 759.196 823.736 718.033L823.238 717.541ZM664 784V783.3C599.648 783.3 541.654 756.079 500.904 712.522L500.393 713L499.881 713.478C540.885 757.307 599.244 784.7 664 784.7V784Z"
            fill="#282828"
          />
          <path
            id="Ellipse 5_3"
            d="M476.5 677L475.72 668.955L469.143 673.653L476.5 677ZM472.837 671.871L473.422 671.488C464.323 657.611 456.138 636.601 450.225 615.591C444.313 594.581 440.7 573.665 440.7 560H440H439.3C439.3 573.848 442.949 594.904 448.878 615.97C454.806 637.036 463.038 658.204 472.252 672.255L472.837 671.871ZM440 560H440.7C440.7 511.681 456.046 466.948 482.131 430.407L481.561 430L480.992 429.593C454.743 466.364 439.3 511.38 439.3 560H440Z"
            fill="#282828"
          />
          <g id="gene-DHFR" {...geneGroupProps("DHFR", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M390 260C390 257.791 391.791 256 394 256H486C488.209 256 490 257.791 490 260V296C490 298.209 488.209 300 486 300H394C391.791 300 390 298.209 390 296V260Z"
                fill={dhfr.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={409.707} y={286.16}>
                  DHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="dhfr"
              groupId="gene-snps"
              genePalette={dhfr}
              startX={398}
              startY={302}
              snpCount={getGeneSnpCount("DHFR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SHMT" {...geneGroupProps("SHMT", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M390 464C390 461.791 391.791 460 394 460H486C488.209 460 490 461.791 490 464V500C490 502.209 488.209 504 486 504H394C391.791 504 390 502.209 390 500V464Z"
                fill={shmt.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={408.91} y={490.16}>
                  SHMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="shmt"
              groupId="gene-snps_2"
              genePalette={shmt}
              startX={398}
              startY={506}
              snpCount={getGeneSnpCount("SHMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTHFD1" {...geneGroupProps("MTHFD1", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M374 535C374 532.791 375.791 531 378 531H489C491.209 531 493 532.791 493 535V571C493 573.209 491.209 575 489 575H378C375.791 575 374 573.209 374 571V535Z"
                fill={mthfd1.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={390.492} y={561.16}>
                  MTHFD1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mthfd1"
              groupId="gene-snps_3"
              genePalette={mthfd1}
              startX={382}
              startY={577}
              snpCount={getGeneSnpCount("MTHFD1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTHFR" {...geneGroupProps("MTHFR", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M599 761C599 758.791 600.791 757 603 757H703C705.209 757 707 758.791 707 761V797C707 799.209 705.209 801 703 801H603C600.791 801 599 799.209 599 797V761Z"
                fill={mthfr.lozengeFill}
              />
              <text
                id="gene-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={615.266} y={787.16}>
                  MTHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mthfr"
              groupId="gene-snps_4"
              genePalette={mthfr}
              startX={607}
              startY={803}
              snpCount={getGeneSnpCount("MTHFR", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationFolateDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={860}
    viewBox="0 142 1024 860"
    fill="none"
    {...props}
  >
    <MethylationFolateDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18291_211481">
        <rect width={1024} height={1002} fill="white" />
      </clipPath>
      <clipPath id="clip1_18291_211481">
        <rect width={1024} height={860} fill="white" transform="translate(0 142)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationFolateDiagram;
